
    import "src/app/AppSeller/SettingsPage/Integrations/ThirdPartyLogisticPreferences/components/DeliveryPartnerCard/index.module.scss?farm_css_modules";
    
    export default {"body": `body-fb0b2d85`,"content": `content-fb0b2d85`,"deliveryPartnerCard": `deliveryPartnerCard-fb0b2d85`,"dropdownIcon": `dropdownIcon-fb0b2d85`,"flex": `flex-fb0b2d85`,"header": `header-fb0b2d85`,"name": `name-fb0b2d85`,"priority": `priority-fb0b2d85`,"sellerIcon": `sellerIcon-fb0b2d85`}
    